import videojs from 'video.js';
import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import store from '../../store';
import { PlayMode } from '@/constants';

// typescript면 enum으로 될텐데
export const ControlButton = {
	SeekBack: 0,
	PlayPause: 1,
	SeekFoward: 2,
	PlayBack: 3,
	Spacer: 5,
	MakeMarker: 6,
	MakeMarkerSection: 7,
	PtzControl: 8,
	FullScreenButton: 9,
	VideoVolumn: 10,
	VideoZoom: 11,
	CurrentTime: 12
}

export function addVideoSeekBackButton(that, position) {
	let rewindBtn = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
	let rewindBtnDom = rewindBtn.el();
	let rewindImagePath = require(`@/assets/images/video_seek_back.png`);
	rewindBtn.addClass('rewind_btn');
	rewindBtnDom.innerHTML = "<img src='" + rewindImagePath + "' style='width:25px; height:25px;' />";
	rewindBtnDom.onclick = () => {
		that.videoRewind(that);
	}
	rewindBtnDom.addEventListener("touchstart", (e)=>{
		that.videoRewind(that);
	});
}

export function addVideoPlayPauseButton(that, position) {
	let playPauseBtn = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
	that.playPauseBtnDom = playPauseBtn.el();
	let playPauseImagePath = require(`@/assets/images/video_pause.png`);
	that.playPauseBtnDom.innerHTML = "<img src='" + playPauseImagePath + "' style='width:25px; height:25px;' />";
  const clickEventHandler = (evt) => {
    evt.preventDefault();
    if(that.videoPlayStatus) {
      that.videoPause();
      that.$store.commit('player/SET_VIDEO_PLAY_STATUS', false);
      that.playPauseBtnDom.innerHTML = "<img src='" + that.playImagePath + "' style='width:16px; height:16px;' />";
    } else {
      that.videoPlay();
      that.$store.commit('player/SET_VIDEO_PLAY_STATUS', true);
      that.playPauseBtnDom.innerHTML = "<img src='" + that.pauseImagePath + "' style='width:25px; height:25px;' />";
    }
    evt.stopPropagation();
  }
	that.playPauseBtnDom.onclick = clickEventHandler;
	that.playPauseBtnDom.addEventListener("touchstart", clickEventHandler);
}

export function addVideoSeekFowardButton(that, position) {
	let forwardBtn = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
	let forwardBtnDom = forwardBtn.el();
	let forwardImagePath = require(`@/assets/images/video_seek_foward.png`);
	forwardBtn.addClass('forward_btn');
	forwardBtnDom.innerHTML = "<img src='" + forwardImagePath + "' style='width:25px; height:25px;' />";
	forwardBtnDom.onclick = () => {
		that.videoForward(that);
	}
	forwardBtnDom.addEventListener("touchstart", (e)=>{
		that.videoForward(that);
	});
}

export function addPlayBackMenuButton(that, position) {
	let MenuButton = videojs.getComponent('MenuButton');
	let MenuItem = videojs.getComponent('MenuItem');

	// ES6 클래스를 사용하여 MenuButton 확장
  class PlayBackMenuButton extends MenuButton {
    createItems() {
      return this.options_.myItems.map((i) => {
        let item = new MenuItem(that.player, {label: i.name});
        const clickEventHandler = () => {
          if (that.playMode === PlayMode.PLAYBACK) {
            if(that.offline) that.offline.sendMessage('playbackspeed',i.value);
            return;
          }
          if (that.onDemand == true) {
            that.player.playbackRate(i.value);
          } else {
            if (i.value <= 1) 
              that.player.playbackRate(i.value);
          }
        }
        item.on('click', clickEventHandler);
        item.on('touchstart', clickEventHandler);
        return item;
      });
    }
  }

  // 새로운 컴포넌트를 Video.js에 등록
  videojs.registerComponent('PlayBackMenuButton', PlayBackMenuButton);

  // addChild를 사용하여 새 컴포넌트의 인스턴스 추가, 옵션과 함께
  let playBackMenu = that.player.controlBar.addChild('PlayBackMenuButton', {
    myItems: that.playBackList
  }, position); // 숫자가 버튼 위치를 결정

  playBackMenu.addClass("playback_menu");

  // 이미지 추가 부분을 ES6 모듈 문법에 맞게 수정
  let playbackMenuImage = document.getElementsByClassName('playback_menu')[0].children[0];
  if (playbackMenuImage) {
    playbackMenuImage.innerHTML = "<img src='" + require(`@/assets/images/playback_x1.png`) + "' style='height:29px;' />";
  }
}

export function updatePlayBackMenuButton(that, position) {
	that.player.controlBar.removeChild('PlayBackMenuButton');
	addPlayBackMenuButton(that, position);
}

export function addSpacer(that, position) {
	let spacer = that.player.controlBar.addChild("spacer", {}, position);
  spacer.addClass("my_spacer");
}

export function addMakeMarkerButton(that, position) {
	let markerBtn = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
	let markerBtnDom = markerBtn.el();
	let markerImagePath = require(`@/assets/images/make_marker.png`);
  markerBtn.addClass('marker_btn');
	markerBtnDom.innerHTML = "<img src='" + markerImagePath + "' style='width:25px; height:25px;' />";
  const clickEventHandler = async () => {
    await that.newBookMark();
    that.getBookMarkListToStore();
    if (that.videoFullScreen) that.player.exitFullscreen();
  }
  markerBtnDom.onclick = clickEventHandler;
  markerBtnDom.addEventListener('touchstart', clickEventHandler);
}

export function addMakeMarkerSectionButton(that, position) {
	let markerSection = that.player.controlBar.addChild("button", {}, position);
  let markerSectionDom = markerSection.el();
	markerSection.addClass('clip_btn');
  markerSectionDom.innerHTML = "<img src='" + require(`@/assets/images/marker_section.png`) + "' style='width:25px; height:25px;' />";
  const clickEventHandler = () => {
    that.displayClip();
    store.commit('player/SET_IS_CLIP_CREATE', true);
    if (that.videoFullScreen) that.player.exitFullscreen();
  }
  markerSectionDom.onclick = clickEventHandler;
	markerSectionDom.addEventListener('touchstart', clickEventHandler);
}

export function addPtzControlButton(that, position) {
	let ptzBtn = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
	let ptzBtnDom = ptzBtn.el();
  ptzBtn.addClass('ptz_btn');
	let ptzImagePath = require(`@/assets/images/ptz.png`);
	ptzBtnDom.innerHTML = "<img src='" + ptzImagePath + "' style='width:25px; height:25px;' />";
  const clickEventHandler = () => {
    that.removeClip();
    store.dispatch('player/togglePtzControlOn');
    if(that.videoFullScreen) {
      that.player.exitFullscreen();
      that.videoFullScreen = false;
    }
  }
	ptzBtnDom.onclick = clickEventHandler
	ptzBtnDom.addEventListener('touchstart', clickEventHandler);
}

export function addCameraLensSettingMenuButton(that, position) {
	let MenuButton2 = videojs.getComponent('MenuButton');
	let MenuItem2 = videojs.getComponent('MenuItem');
	let CustomMenuButton = videojs.extend(
		MenuButton2,
		{
			createItems: function() {
				// Must return an array of `MenuItem`s
				// Options passed in `addChild` are available at `this.options_`
				return this.options_.myItems.map(function (i) {
          var item = new MenuItem2(that.player, {label: i.name});
					item.on('click', function(event) {
						console.log(event.target.innerText);
						console.log(i.value);
					});
          item.addClass("testmenuitem");
          return item;
        });
			},
		}
	);
	// Register as a component, so it can be added
	videojs.registerComponent('CustomMenuButton', CustomMenuButton);
	// Use `addChild` to add an instance of the new component, with options
	let myMenu = that.player.controlBar.addChild('CustomMenuButton', {
		// title: 'my menu',
		myItems: [ 
			{name: '魚眼モード', value: 1}, {name: '歪み補正シングル表示', value: 2},
			{name: 'ダブルパノラマモード', value: 3}, {name: '4分割モード(90°4分割表示)', value: 4}, ]
	}, position);
	myMenu.addClass("my_menu");
}

export function addFullScreenButton(that, position) {
	let fullButton = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
	let fullScreenImagePath = require(`@/assets/images/video_fullscreen.png`);
	let fullButtonDom = fullButton.el();
	fullButtonDom.innerHTML = "<img src='" + fullScreenImagePath + "' style='width:25px; height:25px;' />";
  const clickEventHandler = () => {
    if (that.player.isFullscreen()) {
      that.player.exitFullscreen();
      that.videoFullScreen = false;
      that.panzoom.reset();
    } else {
      that.player.requestFullscreen();
      that.videoFullScreen = true;
    }
  }
	fullButtonDom.onclick = clickEventHandler
	fullButtonDom.addEventListener("touchstart", clickEventHandler);
}

export function updateVideoVolumeButton(that) {
	const button = that.player.controlBar.getChildById('volume_button');
	const soundButtonDom = button.el();
	if(!that.$store.state.isMobile) soundButtonDom.classList.remove("vjs-hidden");
  soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:25px; height:25px;' />";
	// if (that.player.muted()) {
	// 	soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:25px; height:25px;' />";
	// } else {
	// 	soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_max.png`) + "' style='width:25px; height:25px;' />";
	// }
}

export function addVideoVolumnButton(that, position) {
	let soundButton = that.player.controlBar.addChild("button", { id: 'volume_button' }, position); // 숫자가 버튼위치
	let soundButtonDom = soundButton.el();
  soundButton.addClass("sound_btn");
	soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:25px; height:25px;' />";
  
  const clickEventHandler = () => {
    console.log('volume', that.player.volume());
    if (that.player.muted()) {
      soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_max.png`) + "' style='width:25px; height:25px;' />";
    } else {
      soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:25px; height:25px;' />";
    }
    that.player.muted(!that.player.muted());
  }
	soundButtonDom.onclick = clickEventHandler
	soundButtonDom.addEventListener("touchstart", clickEventHandler);
	
	soundButton.on("mouseover", function() {
    document.getElementById("sound_volume_change").style.display = 'flex';
    that.currentSoundBarPosition = $('.sound_btn').position().left - 70;
    that.currentControlBarTopPosition = $('#my-video').height() - $('.sound_btn').height()*2;
	  $("#sound_volume_change").css({'left': `${that.currentSoundBarPosition}px`});
	  $("#sound_volume_change").css({'top': `${that.currentControlBarTopPosition}px`});
  });
  soundButton.on("mouseout", function() {
    document.getElementById("sound_volume_change").style.display = 'none';
  });
}

export function addMicOffButton(that, position) {
	let micButton = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
	that.micButtonDom = micButton.el();
  micButton.addClass("mic_btn");
  let micImagePath = require(`@/assets/images/mic_off.png`);
	that.micButtonDom.innerHTML = "<img src='" + micImagePath + "' style='width:25px; height:25px;' />";
	that.micButtonDom.onclick = () => {
    if(that.micActive == false) {
      that.micDialogVisible = true;
    }
    else {
      that.micActive = false;
      that.micButtonDom.innerHTML = "<img src='" + require(`@/assets/images/mic_off.png`) + "' style='width:27px; height:27px;' />";
      document.getElementById('mic_tooltip').style.display = 'none';
    }
	}
}

export function addVideoZoomButton(that, position) {
	let zoomButton = that.player.controlBar.addChild("button", {}, position); // 숫자가 버튼위치
  that.zoomButtonDom = zoomButton.el();
  zoomButton.addClass("zoom_btn");
  $(".zoom_btn").css({'color': `#B5BED1`});
  that.zoomButtonDom.innerHTML = "<span id=\"zoomScaleText\">" + that.zoomScale * 10 + "%</span>";
  
	zoomButton.on("mouseover", function() {
    document.getElementById("zoom_change").style.display = 'flex';
    that.currentSoundBarPosition = $('.zoom_btn').position().left - 100;
    that.currentControlBarTopPosition = $('#my-video').height() - $('.zoom_btn').height() * 2;
	  $("#zoom_change").css({'left': `${that.currentSoundBarPosition}px`});
	  $("#zoom_change").css({'top': `${that.currentControlBarTopPosition}px`});
  });
  zoomButton.on("mouseout", function() {
    document.getElementById("zoom_change").style.display = 'none';
  });
}

export function addcurrentTime(that, position) {
	let timeDisplay = that.player.controlBar.addChild("button", {}, position);
  that.timeDisplayDom = timeDisplay.el();
  timeDisplay.addClass("time_display");
}